import React, { Component } from 'react';

import Botonera from './Botonera';


/**
 * Dashboard: accesos rápidos (iguales para todos los usuarios, incluido el administrador).
 */
class Dashboard extends Component {
  render() {
    return (
      <div className="animated fadeIn dashboard-accesos">
        <Botonera />
      </div>
    )
  }
}

export default Dashboard;



// WEBPACK FOOTER //
// ./src/views/Dashboard/Dashboard.js